/** The API server's address, fixed when the app is built. */
export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4000';
